import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";
import { trackButtonPressed } from "../../analytics/tracking";
import { AgentTrafficCard } from "./AgentTrafficCard";
import { PipelineVisual } from "./PipelineVisual";
import { WizardFrame } from "./WizardFrame";
import { WizardCta } from "./WizardCta";

/* The confirmation, once traffic has arrived. Only reachable on a real request, so it
 * confirms rather than waits — the waiting lives on the connect step. */
export function VerifyStep({
  onDone,
  onBack,
  onAddAnother,
  ctaLabel = "View agent dashboard",
}: {
  onDone: () => void;
  /** Back to the connect step. Omit to hide the link (nowhere to go back to). */
  onBack?: () => void;
  /** Restart the wizard for another agent (the CLI flow's footer link). */
  onAddAnother?: () => void;
  ctaLabel?: string;
}) {
  return (
    <WizardFrame
      step={2}
      lead="Your agent is talking to the gateway. Here's what we've seen."
    >
      <PipelineVisual used />

      <AgentTrafficCard
        used
        hint="Cost and quality will show up on the dashboard as traffic flows in."
      />

      <div className="mt-1 flex items-center gap-3">
        {onBack && (
          <button
            type="button"
            onClick={() => {
              trackButtonPressed("Back to connect");
              onBack();
            }}
            className="flex shrink-0 items-center gap-2 px-4 py-3 text-[14px] font-medium"
            style={{ color: "#757f8c" }}
          >
            <ArrowLeft size={14} />
            Back
          </button>
        )}
        <WizardCta
          className="flex-1"
          onClick={() => {
            trackButtonPressed(ctaLabel);
            onDone();
          }}
          iconRight={<ArrowRight />}
        >
          {ctaLabel}
        </WizardCta>
      </div>

      {onAddAnother && (
        <button
          type="button"
          onClick={onAddAnother}
          className="self-center text-[13px] font-medium"
          style={{ color: "#757f8c" }}
        >
          Connect another agent
        </button>
      )}
    </WizardFrame>
  );
}
